import { render, staticRenderFns } from "./SchoolTeacherAttendancePage.vue?vue&type=template&id=6a377ff8&scoped=true&"
import script from "./SchoolTeacherAttendancePage.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a377ff8",
  null
  
)

export default component.exports